import { Deserializable } from '../protocols/deserializable';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';

export class VariableBenefitDestinationJurisdictionDetail implements Deserializable {
  public id!: string;
  public governingJurisdictionId!: number | null;
  public lumpSumPaymentAmount!: number | null;
  public minimumAgeSpouseId!: number | null;
  public minimumAgeName!: string;
  public minimumAgeDateOfBirth!: string;
  public recurringPaymentUseMinimumAmount!: boolean;
  public recurringPaymentUseMaximumAmount!: boolean;
  public recurringPaymentAmount!: number | null;
  public governingJurisdiction!: GoverningJurisdictionType | null;

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;

    if (this.governingJurisdiction) {
      this.governingJurisdiction = Deserialize.instanceOf(GoverningJurisdictionType, this.governingJurisdiction);
    }
  }
}
